<template>
    <div class="action-message-items">
        <div class="relative">
            <a
                class="block relative text-lg hover:opacity-40 outline-none"
                href="#"
                role="button"
                @click.prevent="toggleOpen()"
                aria-haspopup="true"
                :aria-expanded="notificationsOpen"
                v-click-outside="closeNotificationsDropdown"
            >
                <i
                    class="fas fa-bell"
                    :class="{ 'ring-bell': ringBell }"
                    v-if="hasUnread"
                ></i>
                <i class="fal fa-bell cursor-not-allowed" v-if="!hasUnread"></i>
                <span
                    v-if="hasUnread"
                    class="rounded-full h-2 w-2 flex items-center justify-center absolute -top-1 -right-1 z-10 text-white bg-red-700"
                ></span>
            </a>
            <div
                class="origin-top-right z-10 absolute top-full right-0 min-w-72 bg-white border border-gray-200 py-1.5 rounded shadow-lg overflow-hidden mt-1"
                v-show="notificationsOpen && notifications.length > 0"
                v-cloak
            >
                <ul class="action-items-list">
                    <li
                        v-for="(notification, $index) in notifications"
                        :key="'key-' + $index"
                    >
                        <a
                            :href="notification.route"
                            class="action-item"
                            v-if="notification.route"
                        >
                            <span v-html="notification.message"></span>
                        </a>
                        <div
                            class="action-item"
                            v-if="!notification.route"
                            v-html="notification.message"
                        ></div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useAppStore } from '@/store/app';

import ClickOutside from 'vue-click-outside';

export default {
    data: () => ({
        notificationsOpen: false,
        notifications: [],
        ringBell: true,
    }),
    directives: {
        ClickOutside,
    },
    watch: {
        notificationsOpen(newVal, oldVal) {
            if (!newVal) {
                this.markAllRead();
            }
        },
        'userSettings.uuid': function (val) {
            if (val) {
                Echo.private(`user.${val}`).listen(
                    '.app.notification',
                    (data) => {
                        data = data.data;
                        if (data.type === 'generic-message') {
                            this.getNotifications();
                            this.$notify(
                                {
                                    group: data.group,
                                    title: data.title,
                                    text: data.message,
                                },
                                4000
                            );
                            this.ringThatBell();
                        }

                        if (data.type === 'failed-connection') {
                            this.getNotifications();
                            this.$notify(
                                {
                                    group: 'error',
                                    title: 'Institution Connection Error',
                                    text:
                                        'There was an issue connecting to ' +
                                        data.member.name +
                                        '. <a href="/wallet/members">Please review the issue here.</a>',
                                },
                                30000
                            );
                            this.ringThatBell();
                        }
                    }
                );
            }
        },
    },
    computed: {
        ...mapState(useAppStore, ['userSettings']),
        hasUnread() {
            return this.notifications.some((item) => {
                return !item.read_at;
            });
        },
    },
    methods: {
        toggleOpen() {
            this.notificationsOpen = !this.notificationsOpen;
        },
        getNotifications() {
            ApiService.apiCall('/notifications', 'get')
                .then((response) => {
                    this.notifications = response.data.notifications;
                })
                .catch((response) => {
                    this.$root.handleHttpStatus(response);
                });
        },
        markAllRead() {
            ApiService.apiCall('/notifications/mark-all-read', 'post')
                .then(() => {
                    this.notifications.forEach((item) => {
                        item.read_at = new Date().toISOString().slice(0, 10);
                    });
                })
                .catch((response) => {
                    console.log('error');
                    this.$root.handleHttpStatus(response);
                });
        },
        closeNotificationsDropdown() {
            this.notificationsOpen = false;
        },
        ringThatBell() {
            this.ringBell = false;
            setTimeout(() => {
                this.ringBell = true;
            }, 1000);
        },
    },
    mounted() {
        this.getNotifications();

        Echo.channel('accounts-sync').listen('.accounts.synced', (data) => {
            data = data.data;
            let accounts = data.accounts;
            if (accounts.length) {
                this.notifications.push({
                    message:
                        "We've successfully connected to your " +
                        data.institution.name +
                        " account. We're currently downloading your account information now.",
                    route: '/mypoints',
                });
                this.$notify(
                    {
                        group: 'success',
                        title: 'Success',
                        text:
                            "We've successfully connected to your " +
                            data.institution.name +
                            " account. We're currently downloading your account information now.",
                    },
                    8000
                );
                this.ringThatBell();
            }
        });

        Echo.channel('member-connection').listen(
            '.member.connection.status',
            (data) => {
                this.getNotifications();
            }
        );

        /*Echo.channel('app-notification').listen('.app.notification', (data) => {

        });*/
    },
};
</script>
